module.exports = __webpack_public_path__ + "img/i_plus_g.52018230.svg";